import React from 'react'

const PurchasebyItem = (props) => {
    const parentDatas = props;
  return (
    <div className="card card-borderless p-1">
      {parentDatas.purchasebyItem.length ? <table style={{ width: "100%" }}>
      <thead>
        <tr style={{ backgroundColor: "#EAF2E3" }}>
          {parentDatas.headers1.map((header, index) => (
            <th
              key={index} style={{fontWeight:"bold"}}
              className={ 
                header === "Amount" || header === "Unit Price"
                  ? "text-end"
                  : ""
              }
            >
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {parentDatas.purchasebyItem.map((item, index) => (
          <tr key={index}>
            <td>{item.itemName}</td>
            <td>{item.quantity}</td>
            <td className="text-end">
              {parentDatas.currency + " " + item.rate.toFixed(2)}
            </td>
            <td className="text-end">
              {parentDatas.currency + " " + item.totalAmount.toFixed(2)}
            </td>
          </tr>
        ))}
      </tbody>
    </table>  : <div className="card card-borderless p-1 justify-content-center align-items-center text-center" style={{height:"400px"}}>
              No data
            </div>}
    
  </div>
  )
}

export default PurchasebyItem